/**
 * ASMM Official Bengkung Grading Examination Syllabus Scheme
 * Extracted directly from: "senarai ujian putih kuning.pdf"
 * 
 * Document: SILIBUS SENI SILAT AWANG SULUNG MERAH MUDA (Pindaan 2023)
 * Association: PERSATUAN SENI SILAT AWANG SULUNG MERAH MUDA NEGERI KEDAH DARUL AMAN
 * ROS Registration: PPM-007-02-28082022
 */

export interface GradingCriteriaItem {
  id: string;
  orderNumber: number | string;
  title: string;
  category: 'Hormat & Adab' | 'Gerak Asas' | 'Jurus Asas' | 'Buah Pukulan' | 'Teknik Beladiri' | 'Asas Tari' | 'Senjata' | 'Kuncian' | 'Dewan Pendekar';
  description?: string;
  isUlangkaji?: boolean;
  maxScore?: number; // Default 5
}

export interface BengkungGradingScheme {
  id: string;
  levelKey: string; // e.g. "putih1", "putih2", "putih3", "merah0", "merah1", "merah2", "merah3", "kuning0"
  displayName: string;
  module: 'Bengkung Putih' | 'Bengkung Merah' | 'Bengkung Kuning';
  badgeUrl: string;
  beltColor: string;
  culaBadgeColor: string;
  targetBengkungCode: string;
  criteria: GradingCriteriaItem[];
  passingScorePercentage: number; // e.g. 60
}

export const UJIAN_GRADING_SYLLABUS_SCHEMES: Record<string, BengkungGradingScheme> = {
  // ----------------------------------------------------
  // BENGKUNG PUTIH CULA 1
  // ----------------------------------------------------
  'putih1': {
    id: 'scheme-putih-1',
    levelKey: 'putih1',
    displayName: 'Bengkung Putih Cula 1',
    module: 'Bengkung Putih',
    badgeUrl: '/badges/putih1-pesilat-muda.png',
    beltColor: '#FFFFFF',
    culaBadgeColor: '#DC2626',
    targetBengkungCode: 'Putih 1',
    passingScorePercentage: 60,
    criteria: [
      {
        id: 'p1-0',
        orderNumber: 0,
        title: 'Hormat Perguruan & Adab Murid',
        category: 'Hormat & Adab',
        description: 'Menyempurnakan adab masuk gelanggang, hormat perguruan, dan salam kependekaran Awang Sulung.',
        isUlangkaji: false,
        maxScore: 5
      },
      // Gerak Asas - Diasingkan satu persatu
      {
        id: 'p1-ga-1',
        orderNumber: 1,
        title: 'Separuh Tiang: Tumbuk Hadapan',
        category: 'Gerak Asas',
        description: 'Kekuda separuh tiang kemas dan koordinasi tumbukan lurus hadapan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-ga-2',
        orderNumber: 2,
        title: 'Separuh Tiang: Tumbuk Bawah',
        category: 'Gerak Asas',
        description: 'Kekuda separuh tiang kemas dan koordinasi tumbukan ke arah bawah.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-ga-3',
        orderNumber: 3,
        title: 'Tendang Depan',
        category: 'Gerak Asas',
        description: 'Tendangan lurus hadapan dengan imbangan badan yang stabil.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-ga-4',
        orderNumber: 4,
        title: 'Tendang Sisi',
        category: 'Gerak Asas',
        description: 'Tendangan sisi dengan imbangan badan dan sasaran padu.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-ga-5',
        orderNumber: 5,
        title: 'Elakan Luar',
        category: 'Gerak Asas',
        description: 'Kelincahan mengelak serangan ke arah sisi luar garis serangan musuh.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-ga-6',
        orderNumber: 6,
        title: 'Elakan Dalam',
        category: 'Gerak Asas',
        description: 'Kelincahan mengelak serangan ke arah sisi dalam garis serangan musuh.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Jurus Asas: Gerakan 1 hingga 5 (badge Jurus Asas)
      {
        id: 'p1-jurus-1',
        orderNumber: 7,
        title: 'Gerakan 1',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas 1 ASMM dengan ketelitian adab dan tapak.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-jurus-2',
        orderNumber: 8,
        title: 'Gerakan 2',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas 2 ASMM dengan koordinasi elakan dan serangan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-jurus-3',
        orderNumber: 9,
        title: 'Gerakan 3',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas 3 ASMM dengan serangan siku dan kekuda.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-jurus-4',
        orderNumber: 10,
        title: 'Gerakan 4',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas 4 ASMM dengan tangkisan dan serangan balas.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-jurus-5',
        orderNumber: 11,
        title: 'Gerakan 5',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas 5 ASMM dengan pasang silat kependekaran.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Buah Pukulan 1: 1.1 - 1.2 (badge Buah Pukulan)
      {
        id: 'p1-buah-1',
        orderNumber: 12,
        title: 'Pukulan 1.1',
        category: 'Buah Pukulan',
        description: 'Aplikasi tangkisan dan serangan balas Buah 1.1 bersama pasangan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-buah-2',
        orderNumber: 13,
        title: 'Pukulan 1.2',
        category: 'Buah Pukulan',
        description: 'Aplikasi tangkisan dan serangan balas Buah 1.2 bersama pasangan.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Teknik Beladiri Tangan kosong (3 teknik)
      {
        id: 'p1-beladiri-tk-1',
        orderNumber: 14,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 1',
        category: 'Teknik Beladiri',
        description: 'Teknik melepaskan diri daripada cengkaman tangan secara tangan kosong.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-beladiri-tk-2',
        orderNumber: 15,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 2',
        category: 'Teknik Beladiri',
        description: 'Teknik menangkis dan menewaskan musuh secara tangan kosong siri 2.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p1-beladiri-tk-3',
        orderNumber: 16,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 3',
        category: 'Teknik Beladiri',
        description: 'Teknik kuncian ringkas tangan kosong siri 3.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Tari (badge Asas Tari, title Tari 1)
      {
        id: 'p1-7',
        orderNumber: 17,
        title: 'Tari 1',
        category: 'Asas Tari',
        description: 'Lembut tari langkah silat pulut bertradisi tanpa mengabaikan ketegasan kependekaran.',
        isUlangkaji: false,
        maxScore: 5
      }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG PUTIH CULA 2
  // ----------------------------------------------------
  'putih2': {
    id: 'scheme-putih-2',
    levelKey: 'putih2',
    displayName: 'Bengkung Putih Cula 2',
    module: 'Bengkung Putih',
    badgeUrl: '/badges/putih2-pesilat-kanan.png',
    beltColor: '#FFFFFF',
    culaBadgeColor: '#DC2626',
    targetBengkungCode: 'Putih 2',
    passingScorePercentage: 65,
    criteria: [
      // Gerak Asas - Diasingkan satu persatu
      {
        id: 'p2-ga-1',
        orderNumber: 1,
        title: 'Separuh Tiang: Tumbuk Hadapan',
        category: 'Gerak Asas',
        description: 'Ulangkaji ketepatan separuh tiang dan daya impak tumbukan hadapan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-2',
        orderNumber: 2,
        title: 'Separuh Tiang: Tumbuk Bawah',
        category: 'Gerak Asas',
        description: 'Ulangkaji ketepatan separuh tiang dan daya impak tumbukan ke arah bawah.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-3',
        orderNumber: 3,
        title: 'Siku Layang',
        category: 'Gerak Asas',
        description: 'Daya sengatan siku layang (horizontal) secara berkesan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-4',
        orderNumber: 4,
        title: 'Siku Atas',
        category: 'Gerak Asas',
        description: 'Siku sodok ke atas berdaya rempuh ke sasaran.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-5',
        orderNumber: 5,
        title: 'Jatuhan Depan',
        category: 'Gerak Asas',
        description: 'Teknik menyerap hentakan selamat bagi jatuhan hadapan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-6',
        orderNumber: 6,
        title: 'Jatuhan Belakang',
        category: 'Gerak Asas',
        description: 'Teknik menyerap hentakan selamat bagi jatuhan ke belakang.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-7',
        orderNumber: 7,
        title: 'Elakan Luar',
        category: 'Gerak Asas',
        description: 'Ulangkaji elakan luar dengan kelajuan dan sudut peralihan yang tepat.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-8',
        orderNumber: 8,
        title: 'Elakan Dalam',
        category: 'Gerak Asas',
        description: 'Ulangkaji elakan dalam dengan kelajuan dan sudut peralihan yang tepat.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-9',
        orderNumber: 9,
        title: 'Tangkisan Tangan',
        category: 'Gerak Asas',
        description: 'Tangkisan padu menggunakan anggota tangan menangkis serangan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-10',
        orderNumber: 10,
        title: 'Tangkisan Kaki',
        category: 'Gerak Asas',
        description: 'Blocking menggunakan tungkai kaki menyekat tendangan musuh.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-11',
        orderNumber: 11,
        title: 'Tendang Depan',
        category: 'Gerak Asas',
        description: 'Ulangkaji tendangan depan dengan kestabilan penuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-12',
        orderNumber: 12,
        title: 'Tendang Sisi',
        category: 'Gerak Asas',
        description: 'Ulangkaji tendangan sisi dengan kestabilan penuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-ga-13',
        orderNumber: 13,
        title: 'Tendang Layang',
        category: 'Gerak Asas',
        description: 'Penguasaan tendang layang memusat berimpak padu.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-ga-14',
        orderNumber: 14,
        title: 'Tendang Sisi Depan',
        category: 'Gerak Asas',
        description: 'Kombinasi tendangan sisi-depan yang pantas dan berdaya tembus.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Jurus Asas: Gerakan 1 hingga 5 (badge Ulangkaji, badge Jurus Asas)
      {
        id: 'p2-jurus-1',
        orderNumber: 15,
        title: 'Gerakan 1',
        category: 'Jurus Asas',
        description: 'Ulangkaji jurus 1 dengan ketelitian adab, tapak dan kekuda.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-jurus-2',
        orderNumber: 16,
        title: 'Gerakan 2',
        category: 'Jurus Asas',
        description: 'Ulangkaji jurus 2 dengan koordinasi elakan dan serangan berturutan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-jurus-3',
        orderNumber: 17,
        title: 'Gerakan 3',
        category: 'Jurus Asas',
        description: 'Ulangkaji jurus 3 dengan daya impak siku dan pergerakan kemas.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-jurus-4',
        orderNumber: 18,
        title: 'Gerakan 4',
        category: 'Jurus Asas',
        description: 'Ulangkaji jurus 4 dengan kelincahan tangkisan dan serangan balas.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-jurus-5',
        orderNumber: 19,
        title: 'Gerakan 5',
        category: 'Jurus Asas',
        description: 'Ulangkaji jurus 5 dengan pasang silat kependekaran Awang Sulung.',
        isUlangkaji: true,
        maxScore: 5
      },

      // Jurus Asas: Gerakan 6 hingga 10 (badge Jurus Asas)
      {
        id: 'p2-jurus-6',
        orderNumber: 20,
        title: 'Gerakan 6',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas lanjutan gerakan 6 ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-jurus-7',
        orderNumber: 21,
        title: 'Gerakan 7',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas lanjutan gerakan 7 ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-jurus-8',
        orderNumber: 22,
        title: 'Gerakan 8',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas lanjutan gerakan 8 ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-jurus-9',
        orderNumber: 23,
        title: 'Gerakan 9',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas lanjutan gerakan 9 ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-jurus-10',
        orderNumber: 24,
        title: 'Gerakan 10',
        category: 'Jurus Asas',
        description: 'Kelancaran jurus asas lanjutan gerakan 10 ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Buah Pukulan 1: 1.1 hingga 1.2 (badge Buah Pukulan, badge Ulangkaji)
      {
        id: 'p2-buah-1',
        orderNumber: 25,
        title: 'Pukulan 1.1',
        category: 'Buah Pukulan',
        description: 'Ulangkaji buah pukulan 1.1 dalam situasi serangan pantas berpasangan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-buah-2',
        orderNumber: 26,
        title: 'Pukulan 1.2',
        category: 'Buah Pukulan',
        description: 'Ulangkaji buah pukulan 1.2 dengan serangan balas dan jatuhan kemas.',
        isUlangkaji: true,
        maxScore: 5
      },

      // Buah Pukulan 1: 1.3 hingga 1.5 (badge Buah Pukulan)
      {
        id: 'p2-buah-3',
        orderNumber: 27,
        title: 'Pukulan 1.3',
        category: 'Buah Pukulan',
        description: 'Persembahan buah pukulan 1.3 bersama pasangan ujian.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-buah-4',
        orderNumber: 28,
        title: 'Pukulan 1.4',
        category: 'Buah Pukulan',
        description: 'Persembahan buah pukulan 1.4 bersama pasangan ujian.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-buah-5',
        orderNumber: 29,
        title: 'Pukulan 1.5',
        category: 'Buah Pukulan',
        description: 'Persembahan buah pukulan 1.5 bersama pasangan ujian.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Teknik Beladiri Tangan kosong (3 teknik)
      {
        id: 'p2-beladiri-tk-1',
        orderNumber: 30,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 1',
        category: 'Teknik Beladiri',
        description: 'Teknik pertahanan diri tangan kosong siri 1 peringkat lanjutan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-beladiri-tk-2',
        orderNumber: 31,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 2',
        category: 'Teknik Beladiri',
        description: 'Teknik pertahanan diri tangan kosong siri 2 peringkat lanjutan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-beladiri-tk-3',
        orderNumber: 32,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 3',
        category: 'Teknik Beladiri',
        description: 'Teknik pertahanan diri tangan kosong siri 3 peringkat lanjutan.',
        isUlangkaji: false,
        maxScore: 5
      },
      // Teknik Beladiri (Senjata - Pisau) (3 teknik dipecahkan)
      {
        id: 'p2-beladiri-pisau-1',
        orderNumber: 33,
        title: 'Beladiri Pisau: Tikaman Hadapan',
        category: 'Teknik Beladiri',
        description: 'Tangkisan tikaman lurus hadapan dan perlucutan senjata pisau.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-beladiri-pisau-2',
        orderNumber: 34,
        title: 'Beladiri Pisau: Tikaman Rusuk',
        category: 'Teknik Beladiri',
        description: 'Elakan tikaman sisi rusuk dan kuncian sendi pergelangan lawan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p2-beladiri-pisau-3',
        orderNumber: 35,
        title: 'Beladiri Pisau: Tikaman Atas / Suduk',
        category: 'Teknik Beladiri',
        description: 'Sangga tikaman dari atas atau sudukan bawah serta teknik perlucutan pisau.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Tari (badge Asas Tari, title Tari 1, Tari 2)
      {
        id: 'p2-14',
        orderNumber: 36,
        title: 'Tari 1',
        category: 'Asas Tari',
        description: 'Ulangkaji keindahan bunga langkah dan tertib tari 1.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p2-15',
        orderNumber: 37,
        title: 'Tari 2',
        category: 'Asas Tari',
        description: 'Pergerakan tari silat pulut siri 2 dengan lenggang dan pasang yang matang.',
        isUlangkaji: false,
        maxScore: 5
      }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG PUTIH CULA 3
  // ----------------------------------------------------
  'putih3': {
    id: 'scheme-putih-3',
    levelKey: 'putih3',
    displayName: 'Bengkung Putih Cula 3',
    module: 'Bengkung Putih',
    badgeUrl: '/badges/putih3-pesilat-sulung.png',
    beltColor: '#FFFFFF',
    culaBadgeColor: '#DC2626',
    targetBengkungCode: 'Putih 3',
    passingScorePercentage: 70,
    criteria: [
      // Gerak Asas - Diasingkan satu persatu
      {
        id: 'p3-ga-1',
        orderNumber: 1,
        title: 'Separuh Tiang: Tumbuk Hadapan',
        category: 'Gerak Asas',
        description: 'Kekuda separuh tiang kemas dan koordinasi tumbukan lurus hadapan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-2',
        orderNumber: 2,
        title: 'Separuh Tiang: Tumbuk Bawah',
        category: 'Gerak Asas',
        description: 'Kekuda separuh tiang kukuh dan ketepatan tumbukan ke arah bawah.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-3',
        orderNumber: 3,
        title: 'Siku Layang',
        category: 'Gerak Asas',
        description: 'Daya sengatan dan ketepatan libasan siku layang mendatar.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-4',
        orderNumber: 4,
        title: 'Siku Atas',
        category: 'Gerak Asas',
        description: 'Sodokan siku tegak ke atas berdaya rempuh ke sasaran lawan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-5',
        orderNumber: 5,
        title: 'Jatuhan Depan',
        category: 'Gerak Asas',
        description: 'Teknik menyerap hentakan selamat bagi jatuhan ke hadapan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-6',
        orderNumber: 6,
        title: 'Jatuhan Belakang',
        category: 'Gerak Asas',
        description: 'Teknik menyerap hentakan selamat bagi jatuhan ke belakang.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-7',
        orderNumber: 7,
        title: 'Elakan Luar',
        category: 'Gerak Asas',
        description: 'Kelincahan mengelak ke arah sisi luar garis serangan musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-8',
        orderNumber: 8,
        title: 'Elakan Dalam',
        category: 'Gerak Asas',
        description: 'Kelincahan mengelak ke arah sisi dalam garis serangan musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-9',
        orderNumber: 9,
        title: 'Tangkisan Tangan',
        category: 'Gerak Asas',
        description: 'Tangkisan padu menggunakan anggota tangan menepis serangan musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-10',
        orderNumber: 10,
        title: 'Tangkisan Kaki',
        category: 'Gerak Asas',
        description: 'Tangkisan blocking menggunakan tungkai kaki menyekat tendangan musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-11',
        orderNumber: 11,
        title: 'Guling Depan',
        category: 'Gerak Asas',
        description: 'Teknik berguling selamat ke hadapan untuk bangkit bersedia.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-12',
        orderNumber: 12,
        title: 'Guling Belakang',
        category: 'Gerak Asas',
        description: 'Teknik berguling selamat ke belakang mengelak ancaman musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-13',
        orderNumber: 13,
        title: 'Guling Sisi',
        category: 'Gerak Asas',
        description: 'Teknik berguling selamat ke sisi melepaskan diri daripada serangan.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-14',
        orderNumber: 14,
        title: 'Tendang Depan',
        category: 'Gerak Asas',
        description: 'Tendangan lurus hadapan dengan imbangan badan dan sasaran padu.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-15',
        orderNumber: 15,
        title: 'Tendang Sisi',
        category: 'Gerak Asas',
        description: 'Tendangan sisi berimpak tinggi dengan kekuda paksi yang kukuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-16',
        orderNumber: 16,
        title: 'Tendang Layang',
        category: 'Gerak Asas',
        description: 'Penguasaan tendang layang memusat ke bahagian rusuk/kepala musuh.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-17',
        orderNumber: 17,
        title: 'Tendang Sisi Depan',
        category: 'Gerak Asas',
        description: 'Kombinasi tendangan sisi-depan yang pantas dan berdaya tembus.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-ga-18',
        orderNumber: 18,
        title: 'Lutut Pacak',
        category: 'Gerak Asas',
        description: 'Serangan jarak dekat menggunakan lutut pacak tegak berdaya impak.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-ga-19',
        orderNumber: 19,
        title: 'Lutut Tunjai',
        category: 'Gerak Asas',
        description: 'Serangan lutut tunjai berdaya rempuh padu ke sasaran lawan.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Jurus Asas: Gerakan 1 hingga 10 (badge Ulangkaji, badge Jurus Asas)
      {
        id: 'p3-jurus-1',
        orderNumber: 20,
        title: 'Gerakan 1',
        category: 'Jurus Asas',
        description: 'Kekuda separuh tiang kemas, penumbuk hadapan dan penguasaan jurus 1.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-2',
        orderNumber: 21,
        title: 'Gerakan 2',
        category: 'Jurus Asas',
        description: 'Koordinasi elakan dan serangan tumbukan berimpak jurus 2.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-3',
        orderNumber: 22,
        title: 'Gerakan 3',
        category: 'Jurus Asas',
        description: 'Kombinasi elakan dalam dan serangan siku layang jurus 3.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-4',
        orderNumber: 23,
        title: 'Gerakan 4',
        category: 'Jurus Asas',
        description: 'Ketangkasan peralihan langkah dan tangkisan mantap jurus 4.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-5',
        orderNumber: 24,
        title: 'Gerakan 5',
        category: 'Jurus Asas',
        description: 'Keseimbangan pasang silat dan kesiapsiagaan jurus 5.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-6',
        orderNumber: 25,
        title: 'Gerakan 6',
        category: 'Jurus Asas',
        description: 'Serangan balas berangkai dan ketangkasan jurus 6.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-7',
        orderNumber: 26,
        title: 'Gerakan 7',
        category: 'Jurus Asas',
        description: 'Tepisan pantas dan serangan ke sasaran jurus 7.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-8',
        orderNumber: 27,
        title: 'Gerakan 8',
        category: 'Jurus Asas',
        description: 'Hentakan siku padu dan penumbuk bawah jurus 8.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-9',
        orderNumber: 28,
        title: 'Gerakan 9',
        category: 'Jurus Asas',
        description: 'Langkah silang dan pertahanan padu jurus 9.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-jurus-10',
        orderNumber: 29,
        title: 'Gerakan 10',
        category: 'Jurus Asas',
        description: 'Penamat rangkaian lengkap 10 jurus asas ASMM tanpa jeda.',
        isUlangkaji: true,
        maxScore: 5
      },

      // Buah Pukulan 1: 1.1 hingga 1.5 (badge Buah Pukulan, badge Ulangkaji)
      {
        id: 'p3-buah-1',
        orderNumber: 30,
        title: 'Pukulan 1.1',
        category: 'Buah Pukulan',
        description: 'Aplikasi tangkisan, serangan balas dan jatuhan Buah 1.1.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-buah-2',
        orderNumber: 31,
        title: 'Pukulan 1.2',
        category: 'Buah Pukulan',
        description: 'Aplikasi tangkisan, sikuan dan jatuhan Buah 1.2.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-buah-3',
        orderNumber: 32,
        title: 'Pukulan 1.3',
        category: 'Buah Pukulan',
        description: 'Aplikasi elakan sisi, pukulan tepat ke rusuk dan kuncian Buah 1.3.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-buah-4',
        orderNumber: 33,
        title: 'Pukulan 1.4',
        category: 'Buah Pukulan',
        description: 'Aplikasi tangkisan, tangkapan tangan dan patah sendi Buah 1.4.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-buah-5',
        orderNumber: 34,
        title: 'Pukulan 1.5',
        category: 'Buah Pukulan',
        description: 'Aplikasi elakan pantas, sangga pukulan dan kuncian leher Buah 1.5.',
        isUlangkaji: true,
        maxScore: 5
      },

      // Buah Pukulan 1: 1.6 hingga 1.10 (badge Buah Pukulan)
      {
        id: 'p3-buah-6',
        orderNumber: 35,
        title: 'Pukulan 1.6',
        category: 'Buah Pukulan',
        description: 'Aplikasi Buah 1.6 dengan ketepatan tangkisan dan serangan balas padu.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-buah-7',
        orderNumber: 36,
        title: 'Pukulan 1.7',
        category: 'Buah Pukulan',
        description: 'Aplikasi Buah 1.7 melibatkan serangan siku bertubi dan rempuhan lutut.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-buah-8',
        orderNumber: 37,
        title: 'Pukulan 1.8',
        category: 'Buah Pukulan',
        description: 'Aplikasi Buah 1.8 dengan tangkisan berlapis dan jatuhan musuh.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-buah-9',
        orderNumber: 38,
        title: 'Pukulan 1.9',
        category: 'Buah Pukulan',
        description: 'Aplikasi Buah 1.9 dengan perangkap tangan lawan dan kuncian sendi bahu.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-buah-10',
        orderNumber: 39,
        title: 'Pukulan 1.10',
        category: 'Buah Pukulan',
        description: 'Aplikasi Buah 1.10 penamat siri Buah Pukulan 1 dengan kuncian mutlak.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Teknik Beladiri Tangan kosong (3 teknik)
      {
        id: 'p3-beladiri-tk-1',
        orderNumber: 40,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 1',
        category: 'Teknik Beladiri',
        description: 'Teknik melepaskan cengkaman tangan/leher dengan elakan dan pukulan balas pantas.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-beladiri-tk-2',
        orderNumber: 41,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 2',
        category: 'Teknik Beladiri',
        description: 'Teknik menangkis serangan tumbuk/tendang musuh diikuti jatuhan pantas ke bumi.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-beladiri-tk-3',
        orderNumber: 42,
        title: 'Teknik Beladiri Tangan Kosong: Teknik 3',
        category: 'Teknik Beladiri',
        description: 'Teknik kuncian sendi pergelangan atau siku lawan secara tangan kosong.',
        isUlangkaji: false,
        maxScore: 5
      },
      // Teknik Beladiri (Senjata - Pisau) (3 teknik dipecahkan)
      {
        id: 'p3-beladiri-pisau-1',
        orderNumber: 43,
        title: 'Beladiri Pisau: Tikaman Hadapan',
        category: 'Teknik Beladiri',
        description: 'Tangkisan tikaman lurus hadapan dan perlucutan senjata pisau.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-beladiri-pisau-2',
        orderNumber: 44,
        title: 'Beladiri Pisau: Tikaman Rusuk',
        category: 'Teknik Beladiri',
        description: 'Elakan tikaman sisi rusuk dan kuncian sendi pergelangan lawan.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-beladiri-pisau-3',
        orderNumber: 45,
        title: 'Beladiri Pisau: Tikaman Atas / Suduk',
        category: 'Teknik Beladiri',
        description: 'Sangga tikaman dari atas atau sudukan bawah serta teknik perlucutan pisau.',
        isUlangkaji: false,
        maxScore: 5
      },
      {
        id: 'p3-15',
        orderNumber: 46,
        title: 'Teknik Beladiri (kuncian & pembuka kuncian)',
        category: 'Kuncian',
        description: 'Seni kuncian persendian lawan serta kaedah membuka kuncian apabila diserang.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Tari (badge Asas Tari, title Tari 1, Tari 2, Tari 3)
      {
        id: 'p3-16',
        orderNumber: 47,
        title: 'Tari 1',
        category: 'Asas Tari',
        description: 'Lembut tari langkah silat pulut bertradisi tanpa mengabaikan ketegasan kependekaran.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-17',
        orderNumber: 48,
        title: 'Tari 2',
        category: 'Asas Tari',
        description: 'Pergerakan tari silat pulut siri 2 dengan lenggang dan pasang yang matang.',
        isUlangkaji: true,
        maxScore: 5
      },
      {
        id: 'p3-18',
        orderNumber: 49,
        title: 'Tari 3',
        category: 'Asas Tari',
        description: 'Persembahan Tari 3 yang menggabungkan keindahan gerak silat tua dan kesiapsiagaan.',
        isUlangkaji: false,
        maxScore: 5
      }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG MERAH (KOSONG - PENDEKAR MERAH MUDA)
  // ----------------------------------------------------
  'merah0': {
    id: 'scheme-merah-0',
    levelKey: 'merah0',
    displayName: 'Bengkung Merah Kosong (Kenaikan Bengkung)',
    module: 'Bengkung Merah',
    badgeUrl: '/badges/merah0-pembantu-jurulatih.png',
    beltColor: '#DC2626',
    culaBadgeColor: '#EAB308',
    targetBengkungCode: 'Merah',
    passingScorePercentage: 75,
    criteria: [
      {
        id: 'm0-hormat',
        orderNumber: 1,
        title: 'Hormat Perguruan & Adab Murid Kanan',
        category: 'Hormat & Adab',
        description: 'Sempurna tertib hormat perguruan, adab ke gelanggang, dan disiplin pesilat kanan.',
        isUlangkaji: false,
        maxScore: 5
      },
      // Jurus Asas 1 hingga 10 (ulangkaji penguasaan penuh)
      { id: 'm0-jurus-1', orderNumber: 2, title: 'Gerakan 1', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 1 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-2', orderNumber: 3, title: 'Gerakan 2', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 2 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-3', orderNumber: 4, title: 'Gerakan 3', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 3 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-4', orderNumber: 5, title: 'Gerakan 4', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 4 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-5', orderNumber: 6, title: 'Gerakan 5', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 5 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-6', orderNumber: 7, title: 'Gerakan 6', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 6 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-7', orderNumber: 8, title: 'Gerakan 7', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 7 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-8', orderNumber: 9, title: 'Gerakan 8', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 8 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-9', orderNumber: 10, title: 'Gerakan 9', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 9 ASMM.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-jurus-10', orderNumber: 11, title: 'Gerakan 10', category: 'Jurus Asas', description: 'Penguasaan jurus asas gerakan 10 ASMM.', isUlangkaji: true, maxScore: 5 },

      // Buah Pukulan 1: 1.1 hingga 1.10
      { id: 'm0-buah-1', orderNumber: 12, title: 'Pukulan 1.1', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-2', orderNumber: 13, title: 'Pukulan 1.2', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-3', orderNumber: 14, title: 'Pukulan 1.3', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-4', orderNumber: 15, title: 'Pukulan 1.4', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-5', orderNumber: 16, title: 'Pukulan 1.5', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.5 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-6', orderNumber: 17, title: 'Pukulan 1.6', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.6 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-7', orderNumber: 18, title: 'Pukulan 1.7', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.7 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-8', orderNumber: 19, title: 'Pukulan 1.8', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.8 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-9', orderNumber: 20, title: 'Pukulan 1.9', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.9 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-buah-10', orderNumber: 21, title: 'Pukulan 1.10', category: 'Buah Pukulan', description: 'Ulangkaji buah pukulan 1.10 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Asas Tari 1 hingga 3
      { id: 'm0-tari-1', orderNumber: 22, title: 'Tari 1', category: 'Asas Tari', description: 'Ulangkaji kesempurnaan bunga langkah tari 1.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-tari-2', orderNumber: 23, title: 'Tari 2', category: 'Asas Tari', description: 'Ulangkaji kelincahan tari silat pulut siri 2.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-tari-3', orderNumber: 24, title: 'Tari 3', category: 'Asas Tari', description: 'Ulangkaji persembahan tari kemuncak siri 3.', isUlangkaji: true, maxScore: 5 },

      // Kuncian & Beladiri
      { id: 'm0-kuncian-1', orderNumber: 25, title: 'Kuncian 1', category: 'Kuncian', description: 'Kuncian pergelangan tangan dan siku.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-kuncian-2', orderNumber: 26, title: 'Kuncian 2', category: 'Kuncian', description: 'Kuncian bahu dan lengan mampat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-kuncian-3', orderNumber: 27, title: 'Kuncian 3', category: 'Kuncian', description: 'Kuncian leher dan jatuhan belakang.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-beladiri-1', orderNumber: 28, title: 'Beladiri: Tangan Kosong 1', category: 'Teknik Beladiri', description: 'Pertahanan dan serangan balas tangan kosong siri 1.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-beladiri-2', orderNumber: 29, title: 'Beladiri: Tangan Kosong 2', category: 'Teknik Beladiri', description: 'Pertahanan dan serangan balas tangan kosong siri 2.', isUlangkaji: true, maxScore: 5 },
      { id: 'm0-beladiri-3', orderNumber: 30, title: 'Beladiri: Pisau', category: 'Teknik Beladiri', description: 'Pertahanan dan perlucutan senjata pisau pendek.', isUlangkaji: true, maxScore: 5 },

      // Kelulusan Dewan Pendekar
      {
        id: 'm0-dewan',
        orderNumber: 31,
        title: 'Kematangan & Adab Kependekaran Dewan Pendekar',
        category: 'Dewan Pendekar',
        description: 'Penilaian khas adab kependekaran, kesetiaan perguruan, dan watikah kelayakan Bengkung Merah.',
        isUlangkaji: false,
        maxScore: 5
      }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG MERAH CULA 1
  // ----------------------------------------------------
  'merah1': {
    id: 'scheme-merah-1',
    levelKey: 'merah1',
    displayName: 'Bengkung Merah Cula 1',
    module: 'Bengkung Merah',
    badgeUrl: '/badges/merah1-pembantu-jurulatih-muda.png',
    beltColor: '#DC2626',
    culaBadgeColor: '#EAB308',
    targetBengkungCode: 'Merah 1',
    passingScorePercentage: 70,
    criteria: [
      // Gerak Asas Senjata: Permainan Sembat (Asas 1 hingga 10 diasingkan)
      { id: 'm1-sembat-1', orderNumber: 1, title: 'Sembat: Asas 1', category: 'Senjata', description: 'Libasan menegak hadapan dengan imbangan kekuda kukuh.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-2', orderNumber: 2, title: 'Sembat: Asas 2', category: 'Senjata', description: 'Libasan sisi kanan membidik sasaran rusuk musuh.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-3', orderNumber: 3, title: 'Sembat: Asas 3', category: 'Senjata', description: 'Libasan sisi kiri mengawal garis tengah tempur.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-4', orderNumber: 4, title: 'Sembat: Asas 4', category: 'Senjata', description: 'Tusukan lurus hadapan terus ke ulu hati lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-5', orderNumber: 5, title: 'Sembat: Asas 5', category: 'Senjata', description: 'Sangga atas menepis tetakan senjata musuh dari atas.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-6', orderNumber: 6, title: 'Sembat: Asas 6', category: 'Senjata', description: 'Sangga bawah menepis libasan senjata arah kaki.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-7', orderNumber: 7, title: 'Sembat: Asas 7', category: 'Senjata', description: 'Libas silang bawah memotong langkah maju lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-8', orderNumber: 8, title: 'Sembat: Asas 8', category: 'Senjata', description: 'Libas silang atas menyerang sudut kepala lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-9', orderNumber: 9, title: 'Sembat: Asas 9', category: 'Senjata', description: 'Putaran sembat hadapan dan belakang pertahanan keliling.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-sembat-10', orderNumber: 10, title: 'Sembat: Asas 10', category: 'Senjata', description: 'Kombinasi serangan pantas bertalu & pasang sembat.', isUlangkaji: false, maxScore: 5 },

      // Buah Sembat 1 hingga 5
      { id: 'm1-bsembat-1', orderNumber: 11, title: 'Buah Sembat 1', category: 'Senjata', description: 'Tangkisan tetakan hadapan dan libasan balas ke kepala.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-bsembat-2', orderNumber: 12, title: 'Buah Sembat 2', category: 'Senjata', description: 'Elakan sisi rusuk dan sudukan pantas ke pinggang lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-bsembat-3', orderNumber: 13, title: 'Buah Sembat 3', category: 'Senjata', description: 'Sangga bawah dan libasan mematahkan kekuda lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-bsembat-4', orderNumber: 14, title: 'Buah Sembat 4', category: 'Senjata', description: 'Kilas bilah sembat dan kuncian pada sendi lengan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-bsembat-5', orderNumber: 15, title: 'Buah Sembat 5', category: 'Senjata', description: 'Patah serangan hadapan dan jatuhan sembat berpasangan.', isUlangkaji: false, maxScore: 5 },

      // Buah Pukulan 2: 2.1 hingga 2.5
      { id: 'm1-buah2-1', orderNumber: 16, title: 'Pukulan 2.1', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.1 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah2-2', orderNumber: 17, title: 'Pukulan 2.2', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.2 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah2-3', orderNumber: 18, title: 'Pukulan 2.3', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.3 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah2-4', orderNumber: 19, title: 'Pukulan 2.4', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.4 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah2-5', orderNumber: 20, title: 'Pukulan 2.5', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.5 berpasangan.', isUlangkaji: false, maxScore: 5 },

      // Buah Pukulan 3: 3.1 hingga 3.5
      { id: 'm1-buah3-1', orderNumber: 21, title: 'Pukulan 3.1', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 3.1 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah3-2', orderNumber: 22, title: 'Pukulan 3.2', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 3.2 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah3-3', orderNumber: 23, title: 'Pukulan 3.3', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 3.3 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah3-4', orderNumber: 24, title: 'Pukulan 3.4', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 3.4 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-buah3-5', orderNumber: 25, title: 'Pukulan 3.5', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 3.5 berpasangan.', isUlangkaji: false, maxScore: 5 },

      // Buah Kuncian 1 hingga 3
      { id: 'm1-kuncian-1', orderNumber: 26, title: 'Kuncian 1', category: 'Kuncian', description: 'Kuncian pergelangan tangan dan sendi siku.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-kuncian-2', orderNumber: 27, title: 'Kuncian 2', category: 'Kuncian', description: 'Kuncian lengan atas dan sendi bahu mampat.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-kuncian-3', orderNumber: 28, title: 'Kuncian 3', category: 'Kuncian', description: 'Kuncian leher dan teknik rebah ke belakang.', isUlangkaji: false, maxScore: 5 },

      // Teknik Beladiri Lanjutan (Senjata Pisau & Parang)
      { id: 'm1-beladiri-1', orderNumber: 29, title: 'Beladiri Pisau: Tikaman Hadapan', category: 'Teknik Beladiri', description: 'Tangkis tikaman lurus hadapan dan perlucutan pisau.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-beladiri-2', orderNumber: 30, title: 'Beladiri Pisau: Tikaman Rusuk', category: 'Teknik Beladiri', description: 'Elakan tikaman sisi rusuk dan kuncian sendi pergelangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-beladiri-3', orderNumber: 31, title: 'Beladiri Parang: Tetakan Atas', category: 'Teknik Beladiri', description: 'Sangga tetakan parang dari atas dan tangkapan lengan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm1-beladiri-4', orderNumber: 32, title: 'Beladiri Parang: Libasan Sisi', category: 'Teknik Beladiri', description: 'Rendah tubuh elak libasan parang sisi dan serangan balas.', isUlangkaji: false, maxScore: 5 }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG MERAH CULA 2
  // ----------------------------------------------------
  'merah2': {
    id: 'scheme-merah-2',
    levelKey: 'merah2',
    displayName: 'Bengkung Merah Cula 2',
    module: 'Bengkung Merah',
    badgeUrl: '/badges/merah2-pembantu-jurulatih-kanan.png',
    beltColor: '#DC2626',
    culaBadgeColor: '#EAB308',
    targetBengkungCode: 'Merah 2',
    passingScorePercentage: 75,
    criteria: [
      // Gerak Asas Senjata: Permainan Sembat (Asas 1 hingga 10) (ulangkaji)
      { id: 'm2-sembat-1', orderNumber: 1, title: 'Sembat: Asas 1', category: 'Senjata', description: 'Ulangkaji libasan menegak hadapan dengan sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-2', orderNumber: 2, title: 'Sembat: Asas 2', category: 'Senjata', description: 'Ulangkaji libasan sisi kanan membidik rusuk.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-3', orderNumber: 3, title: 'Sembat: Asas 3', category: 'Senjata', description: 'Ulangkaji libasan sisi kiri mengawal garis tempur.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-4', orderNumber: 4, title: 'Sembat: Asas 4', category: 'Senjata', description: 'Ulangkaji tusukan lurus hadapan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-5', orderNumber: 5, title: 'Sembat: Asas 5', category: 'Senjata', description: 'Ulangkaji sangga atas senjata sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-6', orderNumber: 6, title: 'Sembat: Asas 6', category: 'Senjata', description: 'Ulangkaji sangga bawah senjata sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-7', orderNumber: 7, title: 'Sembat: Asas 7', category: 'Senjata', description: 'Ulangkaji libas silang bawah memotong langkah.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-8', orderNumber: 8, title: 'Sembat: Asas 8', category: 'Senjata', description: 'Ulangkaji libas silang atas menyerang kepala.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-9', orderNumber: 9, title: 'Sembat: Asas 9', category: 'Senjata', description: 'Ulangkaji putaran sembat pertahanan keliling.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-sembat-10', orderNumber: 10, title: 'Sembat: Asas 10', category: 'Senjata', description: 'Ulangkaji kombinasi serangan bertalu & pasang sembat.', isUlangkaji: true, maxScore: 5 },

      // Gerak Asas Senjata: Permainan Keris (Asas 1 hingga 10)
      { id: 'm2-keris-1', orderNumber: 11, title: 'Keris: Asas 1', category: 'Senjata', description: 'Hormat keris, pegangan hulu & pasang sembah keris.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-2', orderNumber: 12, title: 'Keris: Asas 2', category: 'Senjata', description: 'Tikaman lurus hadapan menusuk garis tengah.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-3', orderNumber: 13, title: 'Keris: Asas 3', category: 'Senjata', description: 'Tikaman bawah menyusup ulu hati.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-4', orderNumber: 14, title: 'Keris: Asas 4', category: 'Senjata', description: 'Tikaman sisi rusuk membelok serangan lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-5', orderNumber: 15, title: 'Keris: Asas 5', category: 'Senjata', description: 'Tatang atas & sangga bilah tajam berkesan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-6', orderNumber: 16, title: 'Keris: Asas 6', category: 'Senjata', description: 'Kilas keris luar menepis senjata arah luar.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-7', orderNumber: 17, title: 'Keris: Asas 7', category: 'Senjata', description: 'Kilas keris dalam melencongkan tikaman dalam.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-8', orderNumber: 18, title: 'Keris: Asas 8', category: 'Senjata', description: 'Langkah tikam silang dengan imbangan gerak padu.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-9', orderNumber: 19, title: 'Keris: Asas 9', category: 'Senjata', description: 'Belitan lok keris pada sendi pergelangan lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-keris-10', orderNumber: 20, title: 'Keris: Asas 10', category: 'Senjata', description: 'Ragam tikaman berangkai & kuncian bilah keris.', isUlangkaji: false, maxScore: 5 },

      // Buah Sembat 1 - 5 (ulangkaji)
      { id: 'm2-bsembat-1', orderNumber: 21, title: 'Buah Sembat 1', category: 'Senjata', description: 'Ulangkaji buah sembat 1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-bsembat-2', orderNumber: 22, title: 'Buah Sembat 2', category: 'Senjata', description: 'Ulangkaji buah sembat 2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-bsembat-3', orderNumber: 23, title: 'Buah Sembat 3', category: 'Senjata', description: 'Ulangkaji buah sembat 3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-bsembat-4', orderNumber: 24, title: 'Buah Sembat 4', category: 'Senjata', description: 'Ulangkaji buah sembat 4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-bsembat-5', orderNumber: 25, title: 'Buah Sembat 5', category: 'Senjata', description: 'Ulangkaji buah sembat 5 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Sembat 6 - 10
      { id: 'm2-bsembat-6', orderNumber: 26, title: 'Buah Sembat 6', category: 'Senjata', description: 'Aplikasi serangan dan pertahanan buah sembat siri 6.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bsembat-7', orderNumber: 27, title: 'Buah Sembat 7', category: 'Senjata', description: 'Aplikasi serangan dan pertahanan buah sembat siri 7.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bsembat-8', orderNumber: 28, title: 'Buah Sembat 8', category: 'Senjata', description: 'Aplikasi serangan dan pertahanan buah sembat siri 8.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bsembat-9', orderNumber: 29, title: 'Buah Sembat 9', category: 'Senjata', description: 'Aplikasi serangan dan pertahanan buah sembat siri 9.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bsembat-10', orderNumber: 30, title: 'Buah Sembat 10', category: 'Senjata', description: 'Kemuncak rangkaian tempur buah sembat siri 10.', isUlangkaji: false, maxScore: 5 },

      // Buah Keris 1 - 5
      { id: 'm2-bkeris-1', orderNumber: 31, title: 'Buah Keris 1', category: 'Senjata', description: 'Sambut tikaman hadapan dan tikaman balas ke dada.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bkeris-2', orderNumber: 32, title: 'Buah Keris 2', category: 'Senjata', description: 'Elak rusuk dan belitan lok keris pada sendi siku lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bkeris-3', orderNumber: 33, title: 'Buah Keris 3', category: 'Senjata', description: 'Tatang atas, sangga bilah lawan dan rebahan ke tanah.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bkeris-4', orderNumber: 34, title: 'Buah Keris 4', category: 'Senjata', description: 'Kilas pergelangan tangan musuh dan perlucutan keris.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-bkeris-5', orderNumber: 35, title: 'Buah Keris 5', category: 'Senjata', description: 'Serapuh tikaman silang dan kuncian mampat dua bilah.', isUlangkaji: false, maxScore: 5 },

      // Buah Pukulan 2: 2.1 hingga 2.5 (ulangkaji)
      { id: 'm2-buah2-1', orderNumber: 36, title: 'Pukulan 2.1', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 2.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah2-2', orderNumber: 37, title: 'Pukulan 2.2', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 2.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah2-3', orderNumber: 38, title: 'Pukulan 2.3', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 2.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah2-4', orderNumber: 39, title: 'Pukulan 2.4', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 2.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah2-5', orderNumber: 40, title: 'Pukulan 2.5', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 2.5 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Pukulan 2: 2.6 hingga 2.10
      { id: 'm2-buah2-6', orderNumber: 41, title: 'Pukulan 2.6', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.6 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah2-7', orderNumber: 42, title: 'Pukulan 2.7', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.7 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah2-8', orderNumber: 43, title: 'Pukulan 2.8', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.8 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah2-9', orderNumber: 44, title: 'Pukulan 2.9', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.9 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah2-10', orderNumber: 45, title: 'Pukulan 2.10', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 2.10 berpasangan.', isUlangkaji: false, maxScore: 5 },

      // Buah Pukulan 3: 3.1 hingga 3.5 (ulangkaji)
      { id: 'm2-buah3-1', orderNumber: 46, title: 'Pukulan 3.1', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 3.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah3-2', orderNumber: 47, title: 'Pukulan 3.2', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 3.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah3-3', orderNumber: 48, title: 'Pukulan 3.3', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 3.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah3-4', orderNumber: 49, title: 'Pukulan 3.4', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 3.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-buah3-5', orderNumber: 50, title: 'Pukulan 3.5', category: 'Buah Pukulan', description: 'Ulangkaji aplikasi pukulan siri 3.5 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Pukulan 4: 4.1 hingga 4.5
      { id: 'm2-buah4-1', orderNumber: 51, title: 'Pukulan 4.1', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 4.1 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah4-2', orderNumber: 52, title: 'Pukulan 4.2', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 4.2 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah4-3', orderNumber: 53, title: 'Pukulan 4.3', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 4.3 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah4-4', orderNumber: 54, title: 'Pukulan 4.4', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 4.4 berpasangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-buah4-5', orderNumber: 55, title: 'Pukulan 4.5', category: 'Buah Pukulan', description: 'Aplikasi serangan dan pukulan siri 4.5 berpasangan.', isUlangkaji: false, maxScore: 5 },

      // Buah Kuncian 1 hingga 3 (ulangkaji)
      { id: 'm2-kuncian-1', orderNumber: 56, title: 'Kuncian 1', category: 'Kuncian', description: 'Ulangkaji kuncian pergelangan tangan dan siku.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-kuncian-2', orderNumber: 57, title: 'Kuncian 2', category: 'Kuncian', description: 'Ulangkaji kuncian lengan atas dan sendi bahu.', isUlangkaji: true, maxScore: 5 },
      { id: 'm2-kuncian-3', orderNumber: 58, title: 'Kuncian 3', category: 'Kuncian', description: 'Ulangkaji kuncian leher dan jatuhan belakang.', isUlangkaji: true, maxScore: 5 },

      // Buah Kuncian 4 hingga 5
      { id: 'm2-kuncian-4', orderNumber: 59, title: 'Kuncian 4', category: 'Kuncian', description: 'Kuncian sendi lutut dan cantasan buku lali pantas.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-kuncian-5', orderNumber: 60, title: 'Kuncian 5', category: 'Kuncian', description: 'Kuncian dua lengan serentak dan perlucutan senjata tajam.', isUlangkaji: false, maxScore: 5 },

      // Teknik Beladiri Lanjutan (Senjata Pisau & Parang)
      { id: 'm2-beladiri-1', orderNumber: 61, title: 'Beladiri Pisau: Serangan Serentak Dua Arah', category: 'Teknik Beladiri', description: 'Pertahanan dan serangan balas menentang tikaman berantai.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-beladiri-2', orderNumber: 62, title: 'Beladiri Parang: Serangan Pantas Bertalu', category: 'Teknik Beladiri', description: 'Tangkisan dan perlucutan tetakan parang jarak dekat.', isUlangkaji: false, maxScore: 5 },
      { id: 'm2-beladiri-3', orderNumber: 63, title: 'Beladiri Senjata: Rampasan & Kuncian Pantas', category: 'Teknik Beladiri', description: 'Rampasan senjata tajam secara mengejut dan kuncian sendi.', isUlangkaji: false, maxScore: 5 }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG MERAH CULA 3
  // ----------------------------------------------------
  'merah3': {
    id: 'scheme-merah-3',
    levelKey: 'merah3',
    displayName: 'Bengkung Merah Cula 3',
    module: 'Bengkung Merah',
    badgeUrl: '/badges/merah3-pembantu-jurulatih-sulung.png',
    beltColor: '#DC2626',
    culaBadgeColor: '#EAB308',
    targetBengkungCode: 'Merah 3',
    passingScorePercentage: 80,
    criteria: [
      // Gerak Asas Senjata: Permainan Sembat (Asas 1 hingga 10) (ulangkaji)
      { id: 'm3-sembat-1', orderNumber: 1, title: 'Sembat: Asas 1', category: 'Senjata', description: 'Ulangkaji libasan menegak sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-2', orderNumber: 2, title: 'Sembat: Asas 2', category: 'Senjata', description: 'Ulangkaji libasan sisi kanan sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-3', orderNumber: 3, title: 'Sembat: Asas 3', category: 'Senjata', description: 'Ulangkaji libasan sisi kiri sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-4', orderNumber: 4, title: 'Sembat: Asas 4', category: 'Senjata', description: 'Ulangkaji tusukan hadapan sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-5', orderNumber: 5, title: 'Sembat: Asas 5', category: 'Senjata', description: 'Ulangkaji sangga atas sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-6', orderNumber: 6, title: 'Sembat: Asas 6', category: 'Senjata', description: 'Ulangkaji sangga bawah sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-7', orderNumber: 7, title: 'Sembat: Asas 7', category: 'Senjata', description: 'Ulangkaji libas silang bawah sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-8', orderNumber: 8, title: 'Sembat: Asas 8', category: 'Senjata', description: 'Ulangkaji libas silang atas sembat.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-9', orderNumber: 9, title: 'Sembat: Asas 9', category: 'Senjata', description: 'Ulangkaji putaran sembat keliling.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-sembat-10', orderNumber: 10, title: 'Sembat: Asas 10', category: 'Senjata', description: 'Ulangkaji kombinasi serangan pantas & pasang sembat.', isUlangkaji: true, maxScore: 5 },

      // Gerak Asas Senjata: Permainan Keris (Asas 1 hingga 10) (ulangkaji)
      { id: 'm3-keris-1', orderNumber: 11, title: 'Keris: Asas 1', category: 'Senjata', description: 'Ulangkaji hormat keris & pasang sembah.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-2', orderNumber: 12, title: 'Keris: Asas 2', category: 'Senjata', description: 'Ulangkaji tikaman lurus hadapan keris.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-3', orderNumber: 13, title: 'Keris: Asas 3', category: 'Senjata', description: 'Ulangkaji tikaman bawah / suduk keris.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-4', orderNumber: 14, title: 'Keris: Asas 4', category: 'Senjata', description: 'Ulangkaji tikaman sisi rusuk keris.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-5', orderNumber: 15, title: 'Keris: Asas 5', category: 'Senjata', description: 'Ulangkaji tatang atas & sangga bilah keris.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-6', orderNumber: 16, title: 'Keris: Asas 6', category: 'Senjata', description: 'Ulangkaji kilas keris luar.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-7', orderNumber: 17, title: 'Keris: Asas 7', category: 'Senjata', description: 'Ulangkaji kilas keris dalam.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-8', orderNumber: 18, title: 'Keris: Asas 8', category: 'Senjata', description: 'Ulangkaji langkah tikam silang keris.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-9', orderNumber: 19, title: 'Keris: Asas 9', category: 'Senjata', description: 'Ulangkaji belitan lok keris pada sendi.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-keris-10', orderNumber: 20, title: 'Keris: Asas 10', category: 'Senjata', description: 'Ulangkaji ragam tikaman berangkai & kuncian keris.', isUlangkaji: true, maxScore: 5 },

      // Gerak Asas Senjata: Cindai (Asas 1 hingga 5)
      { id: 'm3-cindai-1', orderNumber: 21, title: 'Cindai: Libasan Lurus Hadapan', category: 'Senjata', description: 'Teknik melibas hujung kain cindai lurus ke sasaran.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-cindai-2', orderNumber: 22, title: 'Cindai: Putaran & Elakan', category: 'Senjata', description: 'Putaran cindai membentuk dinding pertahanan dari serangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-cindai-3', orderNumber: 23, title: 'Cindai: Jeratan Pergelangan', category: 'Senjata', description: 'Teknik menjerat pergelangan tangan musuh yang bersenjata.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-cindai-4', orderNumber: 24, title: 'Cindai: Jeratan Leher & Jatuhan', category: 'Senjata', description: 'Jeratan kain cindai ke leher lawan dan tarikan rebah.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-cindai-5', orderNumber: 25, title: 'Cindai: Libasan Bawah & Pasang', category: 'Senjata', description: 'Libasan cindai ke arah kaki dan pasang cindai kemas.', isUlangkaji: false, maxScore: 5 },

      // Buah Sembat 1 - 10 (ulangkaji)
      { id: 'm3-bsembat-1', orderNumber: 26, title: 'Buah Sembat 1', category: 'Senjata', description: 'Ulangkaji buah sembat siri 1.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-2', orderNumber: 27, title: 'Buah Sembat 2', category: 'Senjata', description: 'Ulangkaji buah sembat siri 2.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-3', orderNumber: 28, title: 'Buah Sembat 3', category: 'Senjata', description: 'Ulangkaji buah sembat siri 3.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-4', orderNumber: 29, title: 'Buah Sembat 4', category: 'Senjata', description: 'Ulangkaji buah sembat siri 4.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-5', orderNumber: 30, title: 'Buah Sembat 5', category: 'Senjata', description: 'Ulangkaji buah sembat siri 5.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-6', orderNumber: 31, title: 'Buah Sembat 6', category: 'Senjata', description: 'Ulangkaji buah sembat siri 6.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-7', orderNumber: 32, title: 'Buah Sembat 7', category: 'Senjata', description: 'Ulangkaji buah sembat siri 7.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-8', orderNumber: 33, title: 'Buah Sembat 8', category: 'Senjata', description: 'Ulangkaji buah sembat siri 8.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-9', orderNumber: 34, title: 'Buah Sembat 9', category: 'Senjata', description: 'Ulangkaji buah sembat siri 9.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bsembat-10', orderNumber: 35, title: 'Buah Sembat 10', category: 'Senjata', description: 'Ulangkaji buah sembat siri 10.', isUlangkaji: true, maxScore: 5 },

      // Buah Keris 1 - 5 (ulangkaji)
      { id: 'm3-bkeris-1', orderNumber: 36, title: 'Buah Keris 1', category: 'Senjata', description: 'Ulangkaji buah keris siri 1.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bkeris-2', orderNumber: 37, title: 'Buah Keris 2', category: 'Senjata', description: 'Ulangkaji buah keris siri 2.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bkeris-3', orderNumber: 38, title: 'Buah Keris 3', category: 'Senjata', description: 'Ulangkaji buah keris siri 3.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bkeris-4', orderNumber: 39, title: 'Buah Keris 4', category: 'Senjata', description: 'Ulangkaji buah keris siri 4.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-bkeris-5', orderNumber: 40, title: 'Buah Keris 5', category: 'Senjata', description: 'Ulangkaji buah keris siri 5.', isUlangkaji: true, maxScore: 5 },

      // Buah Keris 6 - 10
      { id: 'm3-bkeris-6', orderNumber: 41, title: 'Buah Keris 6', category: 'Senjata', description: 'Pintas tikaman bawah lawan dan teknik jatuhan mampat.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bkeris-7', orderNumber: 42, title: 'Buah Keris 7', category: 'Senjata', description: 'Sangga kilas dan tikaman balasan ke arah belakang lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bkeris-8', orderNumber: 43, title: 'Buah Keris 8', category: 'Senjata', description: 'Kunci dua lok keris dan perlucutan tangan musuh.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bkeris-9', orderNumber: 44, title: 'Buah Keris 9', category: 'Senjata', description: 'Belitan lengan berpasangan dan kawalan bilah tajam.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bkeris-10', orderNumber: 45, title: 'Buah Keris 10', category: 'Senjata', description: 'Ragam kemuncak pertempuran keris warisan ASMM.', isUlangkaji: false, maxScore: 5 },

      // Buah Cindai 1 - 5
      { id: 'm3-bcindai-1', orderNumber: 46, title: 'Buah Cindai 1', category: 'Senjata', description: 'Libasan mata cindai dan sambut tumbukan hadapan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bcindai-2', orderNumber: 47, title: 'Buah Cindai 2', category: 'Senjata', description: 'Belitan lengan musuh dan kuncian sendi pergelangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bcindai-3', orderNumber: 48, title: 'Buah Cindai 3', category: 'Senjata', description: 'Jeratan leher dari belakang dan kawalan rebah lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bcindai-4', orderNumber: 49, title: 'Buah Cindai 4', category: 'Senjata', description: 'Tangkisan parang menggunakan lilitan cindai tegang.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-bcindai-5', orderNumber: 50, title: 'Buah Cindai 5', category: 'Senjata', description: 'Ikat bilah senjata tajam dan rampasan pantas.', isUlangkaji: false, maxScore: 5 },

      // Buah Pukulan 2: 2.1 hingga 2.10 (ulangkaji)
      { id: 'm3-buah2-1', orderNumber: 51, title: 'Pukulan 2.1', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-2', orderNumber: 52, title: 'Pukulan 2.2', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-3', orderNumber: 53, title: 'Pukulan 2.3', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-4', orderNumber: 54, title: 'Pukulan 2.4', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-5', orderNumber: 55, title: 'Pukulan 2.5', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.5 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-6', orderNumber: 56, title: 'Pukulan 2.6', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.6 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-7', orderNumber: 57, title: 'Pukulan 2.7', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.7 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-8', orderNumber: 58, title: 'Pukulan 2.8', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.8 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-9', orderNumber: 59, title: 'Pukulan 2.9', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.9 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah2-10', orderNumber: 60, title: 'Pukulan 2.10', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 2.10 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Pukulan 3: 3.1 hingga 3.5 (ulangkaji)
      { id: 'm3-buah3-1', orderNumber: 61, title: 'Pukulan 3.1', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 3.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah3-2', orderNumber: 62, title: 'Pukulan 3.2', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 3.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah3-3', orderNumber: 63, title: 'Pukulan 3.3', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 3.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah3-4', orderNumber: 64, title: 'Pukulan 3.4', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 3.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah3-5', orderNumber: 65, title: 'Pukulan 3.5', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 3.5 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Pukulan 4: 4.1 hingga 4.5 (ulangkaji)
      { id: 'm3-buah4-1', orderNumber: 66, title: 'Pukulan 4.1', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 4.1 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah4-2', orderNumber: 67, title: 'Pukulan 4.2', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 4.2 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah4-3', orderNumber: 68, title: 'Pukulan 4.3', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 4.3 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah4-4', orderNumber: 69, title: 'Pukulan 4.4', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 4.4 berpasangan.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-buah4-5', orderNumber: 70, title: 'Pukulan 4.5', category: 'Buah Pukulan', description: 'Ulangkaji pukulan siri 4.5 berpasangan.', isUlangkaji: true, maxScore: 5 },

      // Buah Kuncian 1 hingga 5 (ulangkaji)
      { id: 'm3-kuncian-1', orderNumber: 71, title: 'Kuncian 1', category: 'Kuncian', description: 'Ulangkaji kuncian siri 1.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-kuncian-2', orderNumber: 72, title: 'Kuncian 2', category: 'Kuncian', description: 'Ulangkaji kuncian siri 2.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-kuncian-3', orderNumber: 73, title: 'Kuncian 3', category: 'Kuncian', description: 'Ulangkaji kuncian siri 3.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-kuncian-4', orderNumber: 74, title: 'Kuncian 4', category: 'Kuncian', description: 'Ulangkaji kuncian siri 4.', isUlangkaji: true, maxScore: 5 },
      { id: 'm3-kuncian-5', orderNumber: 75, title: 'Kuncian 5', category: 'Kuncian', description: 'Ulangkaji kuncian siri 5.', isUlangkaji: true, maxScore: 5 },

      // Teknik Beladiri Lanjutan (Senjata Tajam & Parang)
      { id: 'm3-beladiri-1', orderNumber: 76, title: 'Beladiri Senjata: Serangan Pantas Berturut-turut', category: 'Teknik Beladiri', description: 'Pertahanan berantai menentang serangan bertalu-talu pelbagai sudut.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-beladiri-2', orderNumber: 77, title: 'Beladiri Senjata: Perlucutan Berpasangan Pantas', category: 'Teknik Beladiri', description: 'Patahkan serangan senjata parang dan perlucutan serta merta.', isUlangkaji: false, maxScore: 5 },
      { id: 'm3-beladiri-3', orderNumber: 78, title: 'Beladiri Senjata: Kawalan Pertahanan Berbilang Arah', category: 'Teknik Beladiri', description: 'Kawalan tapak dan elakan menghadapi ancaman bersenjata tajam.', isUlangkaji: false, maxScore: 5 }
    ]
  },

  // ----------------------------------------------------
  // BENGKUNG KUNING (DEWAN PENDEKAR & TEKPI)
  // ----------------------------------------------------
  'kuning0': {
    id: 'scheme-kuning-0',
    levelKey: 'kuning0',
    displayName: 'Bengkung Kuning',
    module: 'Bengkung Kuning',
    badgeUrl: '/badges/kuning1-junior-instructor-jurulatih-muda.png',
    beltColor: '#EAB308',
    culaBadgeColor: '#0F172A',
    targetBengkungCode: 'Kuning',
    passingScorePercentage: 80,
    criteria: [
      {
        id: 'k0-adab-1',
        orderNumber: 1,
        title: 'Watikah Kependekaran & Sumpah Setia Perguruan',
        category: 'Dewan Pendekar',
        description: 'Pengiktirafan syumul watikah Dewan Pendekar dan bai\'ah setia amanah kepimpinan ASMM.',
        isUlangkaji: false,
        maxScore: 5
      },

      // Gerak Asas Senjata: Permainan Tekpi (Asas 1 hingga 10)
      { id: 'k0-tekpi-1', orderNumber: 2, title: 'Tekpi: Asas 1', category: 'Senjata', description: 'Kekuda pasang tekpi dan hormat senjata cabang.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-2', orderNumber: 3, title: 'Tekpi: Asas 2', category: 'Senjata', description: 'Tikaman kembar hadapan dengan ketegasan ulu hati.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-3', orderNumber: 4, title: 'Tekpi: Asas 3', category: 'Senjata', description: 'Tikaman silih berganti kiri dan kanan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-4', orderNumber: 5, title: 'Tekpi: Asas 4', category: 'Senjata', description: 'Sangga cabang atas menahan tetakan senjata tajam.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-5', orderNumber: 6, title: 'Tekpi: Asas 5', category: 'Senjata', description: 'Sangga silang bawah melindungi garis kaki.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-6', orderNumber: 7, title: 'Tekpi: Asas 6', category: 'Senjata', description: 'Kilas cabang luar memotong arah serangan lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-7', orderNumber: 8, title: 'Tekpi: Asas 7', category: 'Senjata', description: 'Kilas cabang dalam memerangkap bilah musuh.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-8', orderNumber: 9, title: 'Tekpi: Asas 8', category: 'Senjata', description: 'Putaran roda tekpi pertahanan pantas serbaguna.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-9', orderNumber: 10, title: 'Tekpi: Asas 9', category: 'Senjata', description: 'Sudukan rusuk dan cangkukan cabang ke leher lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-tekpi-10', orderNumber: 11, title: 'Tekpi: Asas 10', category: 'Senjata', description: 'Ragam langkah tempur tekpi kependekaran ASMM.', isUlangkaji: false, maxScore: 5 },

      // Buah Tekpi (Buah 1 hingga 10)
      { id: 'k0-btekpi-1', orderNumber: 12, title: 'Buah Tekpi 1', category: 'Senjata', description: 'Patah serangan parang dan tikaman balas ke rusuk.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-2', orderNumber: 13, title: 'Buah Tekpi 2', category: 'Senjata', description: 'Sangga atas dan jepitan bilah senjata musuh.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-3', orderNumber: 14, title: 'Buah Tekpi 3', category: 'Senjata', description: 'Elakan tikaman pisau dan cangkuk sendi lengan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-4', orderNumber: 15, title: 'Buah Tekpi 4', category: 'Senjata', description: 'Kilas sendi siku lawan dan pulasan lucut senjata.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-5', orderNumber: 16, title: 'Buah Tekpi 5', category: 'Senjata', description: 'Tangkis silang serentak dan sudukan ke kerongkong.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-6', orderNumber: 17, title: 'Buah Tekpi 6', category: 'Senjata', description: 'Jepit bilah pedang panjang dan patahkan serangan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-7', orderNumber: 18, title: 'Buah Tekpi 7', category: 'Senjata', description: 'Serapuh cabang tekpi dan hentakan ulu tekpi berkesan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-8', orderNumber: 19, title: 'Buah Tekpi 8', category: 'Senjata', description: 'Tangkisan bawah dan cantasan mematahkan tapak lawan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-9', orderNumber: 20, title: 'Buah Tekpi 9', category: 'Senjata', description: 'Belitan ganda dua cabang tekpi dan jatuhan hadapan.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-btekpi-10', orderNumber: 21, title: 'Buah Tekpi 10', category: 'Senjata', description: 'Kemuncak pentas pertempuran senjata tekpi ASMM.', isUlangkaji: false, maxScore: 5 },

      // Kemuncak Kuncian & Buah Pukulan Rahsia Lanjutan
      { id: 'k0-kuncian-1', orderNumber: 22, title: 'Kuncian Maut 1', category: 'Kuncian', description: 'Kuncian tiga sendi tangan kosong serentak.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-kuncian-2', orderNumber: 23, title: 'Kuncian Maut 2', category: 'Kuncian', description: 'Kuncian pangkal leher dan kawalan tulang belakang.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-kuncian-3', orderNumber: 24, title: 'Kuncian Maut 3', category: 'Kuncian', description: 'Kuncian pertahanan serangan senjata tajam berkembar.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-pukulan-1', orderNumber: 25, title: 'Pukulan Rahsia 1', category: 'Buah Pukulan', description: 'Pukulan titik kelemahan hadapan pantas mematikan gerak.', isUlangkaji: false, maxScore: 5 },
      { id: 'k0-pukulan-2', orderNumber: 26, title: 'Pukulan Rahsia 2', category: 'Buah Pukulan', description: 'Pukulan pemati gerak berpasangan warisan perguruan.', isUlangkaji: false, maxScore: 5 }
    ]
  }
};

export const STORAGE_KEY_GRADING_SCHEMES = 'asmm_grading_syllabus_schemes_v4';
export const STORAGE_KEY_GRADING_RULES = 'asmm_grading_general_rules_v1';

export interface GradingGeneralRules {
  minExaminerBengkung: string; // e.g. 'Bengkung Kuning'
  requireAllCriteriaRated: boolean; // default true
  certificatePrefixTemplate: string; // default 'ASMM/GRD/{YEAR}/{ID}'
}

export const DEFAULT_GRADING_RULES: GradingGeneralRules = {
  minExaminerBengkung: 'Bengkung Kuning',
  requireAllCriteriaRated: true,
  certificatePrefixTemplate: 'ASMM/GRD/{YEAR}/{ID}'
};

export function getCustomGradingSchemes(): Record<string, BengkungGradingScheme> {
  if (typeof window === 'undefined') return UJIAN_GRADING_SYLLABUS_SCHEMES;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_GRADING_SCHEMES);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
        return {
          ...UJIAN_GRADING_SYLLABUS_SCHEMES,
          ...parsed
        };
      }
    }
  } catch (err) {
    console.error('Error reading custom grading schemes from localStorage:', err);
  }
  return UJIAN_GRADING_SYLLABUS_SCHEMES;
}

export function saveCustomGradingSchemes(schemes: Record<string, BengkungGradingScheme>): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_GRADING_SCHEMES, JSON.stringify(schemes));
    window.dispatchEvent(new CustomEvent('asmm_grading_syllabus_updated', { detail: schemes }));
  } catch (err) {
    console.error('Error saving custom grading schemes to localStorage:', err);
  }
}

export function resetCustomGradingSchemes(): Record<string, BengkungGradingScheme> {
  if (typeof window === 'undefined') return UJIAN_GRADING_SYLLABUS_SCHEMES;
  try {
    localStorage.removeItem(STORAGE_KEY_GRADING_SCHEMES);
    window.dispatchEvent(new CustomEvent('asmm_grading_syllabus_updated', { detail: UJIAN_GRADING_SYLLABUS_SCHEMES }));
  } catch (err) {
    console.error('Error resetting custom grading schemes:', err);
  }
  return UJIAN_GRADING_SYLLABUS_SCHEMES;
}

export function getGradingGeneralRules(): GradingGeneralRules {
  if (typeof window === 'undefined') return DEFAULT_GRADING_RULES;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_GRADING_RULES);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...DEFAULT_GRADING_RULES, ...parsed };
    }
  } catch (err) {
    console.error('Error reading grading rules:', err);
  }
  return DEFAULT_GRADING_RULES;
}

export function saveGradingGeneralRules(rules: GradingGeneralRules): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_GRADING_RULES, JSON.stringify(rules));
    window.dispatchEvent(new CustomEvent('asmm_grading_rules_updated', { detail: rules }));
  } catch (err) {
    console.error('Error saving grading rules:', err);
  }
}

/**
 * Helper to match any target bengkung string (e.g. "Putih 1", "putih 2", "Merah 3", "Kuning")
 * to the corresponding BengkungGradingScheme with custom scheme override support.
 */
export function getGradingSchemeForTargetBengkung(targetBengkungRaw: string, customSchemes?: Record<string, BengkungGradingScheme>): BengkungGradingScheme {
  const norm = (targetBengkungRaw || '').toLowerCase().trim();
  const schemes = customSchemes || getCustomGradingSchemes();

  if (norm.includes('kuning')) return schemes['kuning0'] || UJIAN_GRADING_SYLLABUS_SCHEMES['kuning0'];
  if (norm.includes('merah') && (norm.includes('3') || norm.includes('cula 3'))) return schemes['merah3'] || UJIAN_GRADING_SYLLABUS_SCHEMES['merah3'];
  if (norm.includes('merah') && (norm.includes('2') || norm.includes('cula 2'))) return schemes['merah2'] || UJIAN_GRADING_SYLLABUS_SCHEMES['merah2'];
  if (norm.includes('merah') && (norm.includes('1') || norm.includes('cula 1'))) return schemes['merah1'] || UJIAN_GRADING_SYLLABUS_SCHEMES['merah1'];
  if (norm.includes('merah')) return schemes['merah0'] || UJIAN_GRADING_SYLLABUS_SCHEMES['merah0'];
  if (norm.includes('putih') && (norm.includes('3') || norm.includes('cula 3'))) return schemes['putih3'] || UJIAN_GRADING_SYLLABUS_SCHEMES['putih3'];
  if (norm.includes('putih') && (norm.includes('2') || norm.includes('cula 2'))) return schemes['putih2'] || UJIAN_GRADING_SYLLABUS_SCHEMES['putih2'];
  if (norm.includes('putih') && (norm.includes('1') || norm.includes('cula 1'))) return schemes['putih1'] || UJIAN_GRADING_SYLLABUS_SCHEMES['putih1'];
  if (norm.includes('putih')) return schemes['putih1'] || UJIAN_GRADING_SYLLABUS_SCHEMES['putih1'];

  return schemes['putih1'] || UJIAN_GRADING_SYLLABUS_SCHEMES['putih1'];
}
